export default __webpack_public_path__ + "images/HF.930eab7.png";